/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_HungarianInputs */



/**
* | output |
* | --- |
* | "Hungarian" |
*
* @param {Speechmatics_Target_Language_HungarianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_hungarian = /** @type {((inputs?: Speechmatics_Target_Language_HungarianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_HungarianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Hongrois")
	if (locale === "de") return /** @type {LocalizedString} */ ("ungarisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("ungherese")
	if (locale === "ru") return /** @type {LocalizedString} */ ("венгерский")
	if (locale === "es") return /** @type {LocalizedString} */ ("húngaro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("匈牙利")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ハンガリー語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हंगेरी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("húngaro")
	return /** @type {LocalizedString} */ ("Hungarian")
});